import React, { useMemo } from 'react';
import MarkdownWithKatex from './MarkdownWithKatex';
import { removeMcqOptions, sanitizeMessage } from '../../../utils';
import SelectOptions from './SelectOptions';
import ChatAvatar from './ChatAvatar';
import { cn } from '../../ui/utils';

export default function Message({
  id,
  message,
  photoURL,
  displayName = '',
  isSentByUser = false,
  selectMcqOption
}) {
  const sanitizedMessageWithoutMcqOptions = useMemo(() => {
    return sanitizeMessage(removeMcqOptions(message));
  }, [message]);

  const isTyping = !isSentByUser && message === '';
  const identityLabel = isSentByUser
    ? displayName?.trim() || 'You'
    : displayName?.trim() || 'Classwise';

  return (
    <div
      className={cn('my-3 flex w-full md:my-4', isSentByUser ? 'justify-end' : 'justify-start')}
      id={id}
    >
      <div
        className={cn(
          'relative inline-block max-w-[92%] animate-in fade-in slide-in-from-bottom-2 duration-300 md:max-w-[88%]',
          isSentByUser ? 'pr-3' : 'pl-3'
        )}
      >
        <ChatAvatar
          src={photoURL}
          name={identityLabel}
          isUser={isSentByUser}
          className={cn(
            'absolute top-0 z-10 h-7 w-7 ring-2 ring-white md:h-8 md:w-8',
            isSentByUser ? 'right-2' : 'left-2'
          )}
        />

        <div
          className={cn(
            'w-fit max-w-full break-words text-sm leading-relaxed md:text-base',
            isSentByUser
              ? 'cw-chat-bubble-user mr-3 md:mr-4'
              : 'cw-chat-bubble-ai htmlMarkdown ml-3 md:ml-4'
          )}
        >
          {isTyping ? (
            <div className="flex items-center gap-1 py-1" aria-label="AI is typing">
              <span
                className={cn(
                  'h-2 w-2 animate-bounce rounded-full [animation-delay:-0.3s]',
                  isSentByUser ? 'bg-primary-foreground/50' : 'bg-muted-foreground/40'
                )}
              />
              <span
                className={cn(
                  'h-2 w-2 animate-bounce rounded-full [animation-delay:-0.15s]',
                  isSentByUser ? 'bg-primary-foreground/50' : 'bg-muted-foreground/40'
                )}
              />
              <span
                className={cn(
                  'h-2 w-2 animate-bounce rounded-full',
                  isSentByUser ? 'bg-primary-foreground/50' : 'bg-muted-foreground/40'
                )}
              />
            </div>
          ) : (
            <>
              <MarkdownWithKatex>{sanitizedMessageWithoutMcqOptions}</MarkdownWithKatex>
              <SelectOptions message={message} selectMcqOption={selectMcqOption} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
